import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import MenuPlannerHeader from '../../component/view/MenuPlannerHeader.vue'
import MenuPlannerShow from '../../component/view/MenuPlannerShow.vue'
import MenuPlannerEdit from '../../component/view/MenuPlannerEdit.vue'

if ($('#menu-planner').length) {
  Vue.use(VueResource)
  Vue.use(Vuex)
  const routes = [
    {
      path: '/',
      name: 'menu-planner-home',
      components: { header: MenuPlannerHeader },
      props: { header: true }
    },
    {
      path: '/show/:date/:brand',
      name: 'menu-planner-show',
      components: {
        header: MenuPlannerHeader,
        body: MenuPlannerShow
      },
      props: {
        header: route => ({
          date: route.params.date,
          brand: route.params.brand,
          package: route.query.package
        }),
        body: route => ({
          date: route.params.date,
          brand: route.params.brand,
          package: route.query.package
        })
      }
    },
    {
      path: '/edit/:date/:brand/:showDate',
      name: 'menu-planner-edit',
      components: {
        header: MenuPlannerHeader,
        body: MenuPlannerEdit
      },
      props: {
        header: route => ({
          date: route.params.date,
          brand: route.params.brand,
          showDate: route.params.showDate,
          package: route.query.package
        }),
        body: route => ({
          date: route.params.date,
          brand: route.params.brand,
          showDate: route.params.showDate,
          package: route.query.package
        })
      }
    },
  ]

  const router = new VueRouter({
    routes
  })

  const store = new Vuex.Store({
    state: {
      copyFromDate: null,
      copyFromBrandId: null,
      dateData: {},
      dateDataIsLoading: false,
      editViewLoading: true
    },
    mutations: {
      changeCopyFromDate (state, { date, brand, fromBrand }) {
        state.copyFromBrandId = fromBrand
        state.copyFromDate = date
        let url = Routing.generate('api_show_menu_planner', {
          brand: brand,
          date: date
        })

        if (fromBrand) {
          url = `${url}?from_brand_id=${fromBrand}`
        }

        state.dateDataIsLoading = true
        Vue.http.get(url).then((res) => {
          state.dateData = res.data[date]
          state.dateDataIsLoading = false
        }).catch(() => {
          state.dateDataIsLoading = false
        })
      },
      setEditViewLoading(state, loading) {
        state.editViewLoading = loading
      }
    }
  })

  Vue.use(VueRouter)

  new Vue({
    router,
    store
  }).$mount('#menu-planner')
}
